import { apiQuery, atsApiQuery } from '../';

// Search excludes anonymized (GDPR-erased) candidates by default (contract
// delta 2 §3); the contact list must still show them.
export const buildContactsSearchRequest = ({ payload = {} } = {}) => ({
  method: 'post',
  data: { ...payload, include_anonymized: true },
  url: `/search/circles/contacts`,
});

export const contactsOldApi = apiQuery.injectEndpoints({
  endpoints: (builder) => {
    return {
      getAllContacts: builder.query({
        providesTags: ['GetAllContacts'],
        transformResponse: (response) => response?.data,
        query: buildContactsSearchRequest,
      }),

      getContactById: builder.query({
        providesTags: ['GetContactById'],
        transformResponse: (response) => response?.data?.contact,
        query: ({ contactId }) => {
          return {
            method: 'get',
            url: `/contacts/${contactId}`,
          };
        },
      }),

      markContactAsTopTalent: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ contactId, payload }) => {
          return {
            url: `/user_contacts/${contactId}`,
            method: 'post',
            data: { ...payload },
          };
        },
      }),

      contactTalent: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ payload, contactId }) => {
          return {
            url: `/user_contacts/${contactId}`,
            method: 'put',
            data: { ...payload },
          };
        },
        invalidatesTags: (result) => {
          if (result) {
            return [{ type: 'GetAllContacts' }];
          }
          return [];
        },
      }),
    };
  },
  overrideExisting: true,
});

//new endpoint ats
export const contactsNewApi = atsApiQuery.injectEndpoints({
  endpoints: (builder) => {
    return {
      createContact: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ payload }) => {
          return {
            url: '/contacts',
            method: 'post',
            data: { ...payload },
          };
        },
        invalidatesTags: (result) => {
          if (result) {
            return [{ type: 'GetAllContacts' }];
          }
          return [];
        },
      }),

      importContacts: builder.mutation({
        // Sync add responds with the created applications under `data`; the
        // bulk-activity add responds with `{ id, dispatch_session_id }` and no
        // `data` array. Return the whole envelope in the bulk case so AddToJob
        // can start the stage-automation underway popup from
        // `dispatch_session_id`. Sync callers are unaffected — an array `data`
        // still unwraps to the array exactly as before.
        transformResponse: (response) =>
          Array.isArray(response?.data) ? response.data : response,
        query: ({ payload }) => {
          return {
            url: `ats_applications/bulk_create_from_contacts`,
            method: 'post',
            data: { ...payload },
          };
        },
      }),
    };
  },
  overrideExisting: true,
});

export const {
  useLazyGetAllContactsQuery,
  useLazyGetContactByIdQuery,
  useContactTalentMutation,
} = contactsOldApi;

export const { useCreateContactMutation, useImportContactsMutation } =
  contactsNewApi;
